<template>
    <div style="display: contents;">
        <div class="event-header">
            <div class="icon-common size28-21"></div>
            <div class="c-blue pl3 fz14 fw700 fg-1">Minglepass Event</div>
            <button class="icon-event-list search" @click="$router.push('/event/search')"></button>
        </div>
        <event-list-component :eventType="'event'"></event-list-component>
        <event-normal-filter-modal></event-normal-filter-modal>
        <non-button-update-sort-modal></non-button-update-sort-modal>
    </div>
</template>


<script>
import PageHeader from "@/components/PageHeader.vue";
import alertMixins from "@/mixins/alertMixins";
import EventListComponent from '@/components/event/EventListComponent.vue';
import EventNormalFilterModal from '@/components/modal/EventNormalFilterModal.vue';
import NonButtonUpdateSortModal from '@/components/modal/NonButtonUpdateSortModal.vue';

export default {
    name: "Event",
    mixins: [alertMixins],
    components: {
        PageHeader,
        EventListComponent,
        EventNormalFilterModal,
        NonButtonUpdateSortModal,
    },
    props: {},
    data() {
        return {};
    },
    beforeRouterEnter() {},
    created() {},
    mounted() {},
    beforeUnmount() {},
    unmounted() {},
    computed: {
        
    },
    methods: {},
    watch: {},
};
</script>
